var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45473 0V1.00868C4.85587 0.767473 4.21371 0.643215 3.57155 0.643215C2.28002 0.643215 0.98849 1.14025 0 2.14161L2.40268 4.5756H3.20357V5.38693C3.82409 6.01553 4.63219 6.34444 5.44752 6.38099V8.04019H3.29016V10.233C3.29016 11.037 3.93953 11.6948 4.73321 11.6948H11.9485C13.1462 11.6948 14.113 10.7154 14.113 9.50204V0H5.45473ZM4.65384 4.68524V3.11375H3.00876L2.25838 2.35358C2.66964 2.19278 3.11699 2.10507 3.57155 2.10507C4.5384 2.10507 5.4403 2.48515 6.12575 3.17222L7.1431 4.20283L6.9988 4.34901C6.63082 4.72179 6.14018 4.93375 5.61347 4.93375C5.27435 4.93375 4.94245 4.84604 4.65384 4.68524ZM12.67 9.50204C12.67 9.90405 12.3453 10.233 11.9485 10.233C11.5516 10.233 11.2269 9.90405 11.2269 9.50204V8.04019H6.89778V6.14709C7.30905 5.97898 7.69146 5.73046 8.02337 5.39424L8.16767 5.24805L10.2096 7.30927H11.2269V6.27866L6.89778 1.91503V1.46185H12.67V9.50204Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.ccde750900377d166e18b4db3386beba.svg";
export { ForwardRef as ReactComponent };